<p-toast [key]="toastKey" position="top-right"></p-toast>
<fieldset [ngClass]="classeModeApplication">
	<legend>{{ 'SIGALE_ANGULAR.COMPONENTS.STATUT.TITRE' | translate }}</legend>
	<hr *ngIf="!modeApplicationCohabitation">
	<div *ngIf="appStatus?.down" class="col">
		<div>
					<span translate="SIGALE_ANGULAR.COMPONENTS.STATUT.STATUT"
						  [translateParams]="{statut: 'DOWN', date: appStatus?.timestamp | date: 'dd / MM' , heure: appStatus?.timestamp | date: 'HH : mm' }"></span>
			{{ 'SIGALE_ANGULAR.COMPONENTS.STATUT.MSG_DOWN' | translate }}
		</div>

		<button *ngIf="modeApplicationCohabitation"
				type="button"
				class="btn btn-medium float-right"
				title="{{ 'SIGALE_ANGULAR.COMPONENTS.STATUT.BTN_DOWN' | translate }}"
				(click)="setApplicationUp()">
			<i class="icon-thumbs-up"></i> {{ 'SIGALE_ANGULAR.COMPONENTS.STATUT.BTN_DOWN' | translate }}
		</button>
		<button *ngIf="!modeApplicationCohabitation"
				pButton
				class="float-right bouton-admin btn"
				[title]="'SIGALE_ANGULAR.COMPONENTS.STATUT.BTN_DOWN' | translate"
				icon="pi pi-thumbs-up"
				[label]="'SIGALE_ANGULAR.COMPONENTS.STATUT.BTN_DOWN' | translate"
				(click)="setApplicationUp()">
		</button>
	</div>
	<div *ngIf="!appStatus?.down" class="col">
		<div>
			<span translate="SIGALE_ANGULAR.COMPONENTS.STATUT.STATUT"
				   [translateParams]="{statut: 'UP', date: appStatus?.timestamp | date: 'dd / MM', heure: appStatus?.timestamp | date: 'HH : mm' }"></span>
			{{ 'SIGALE_ANGULAR.COMPONENTS.STATUT.MSG_UP' | translate }}
		</div>

		<button *ngIf="modeApplicationCohabitation"
				type="button"
				class="btn btn-medium float-right"
				title="{{ 'SIGALE_ANGULAR.COMPONENTS.STATUT.BTN_UP' | translate }}"
				(click)="setApplicationDown()">
			<i class="icon-thumbs-down"></i> {{ 'SIGALE_ANGULAR.COMPONENTS.STATUT.BTN_UP' | translate }}
		</button>
		<button *ngIf="!modeApplicationCohabitation"
				pButton
				class="float-right bouton-admin btn"
				[title]="'SIGALE_ANGULAR.COMPONENTS.STATUT.BTN_UP' | translate"
				icon="pi pi-thumbs-down"
				[label]="'SIGALE_ANGULAR.COMPONENTS.STATUT.BTN_UP' | translate"
				(click)="setApplicationDown()">
		</button>
	</div>
</fieldset>
